@if (isVisible) {
    <aside class="onboarding" [class.collapsed]="isCollapsed" [attr.aria-label]="'onboarding.title' | translate">
        @if (isCollapsed) {
            <button type="button" class="onboarding__pill" (click)="toggleCollapsed()" [attr.aria-expanded]="false">
                <span class="onboarding__pill-title">{{ 'onboarding.title' | translate }}</span>
                <span class="onboarding__pill-count">{{ doneCount }}/{{ steps.length }}</span>
                <i-feather name="chevron-up" class="onboarding__icon"></i-feather>
            </button>
        } @else {
            <div class="onboarding__card">
                <header class="onboarding__header">
                    <div>
                        <h2 class="onboarding__title">{{ 'onboarding.title' | translate }}</h2>
                        <p class="onboarding__subtitle">
                            {{ 'onboarding.progress' | translate: { done: doneCount, total: steps.length } }}
                        </p>
                    </div>
                    <div class="onboarding__header-actions">
                        <button
                            type="button"
                            class="onboarding__icon-button"
                            (click)="toggleCollapsed()"
                            [attr.aria-expanded]="true"
                            [attr.aria-label]="'onboarding.collapse' | translate"
                            [title]="'onboarding.collapse' | translate">
                            <i-feather name="chevron-down" class="onboarding__icon"></i-feather>
                        </button>
                        <button
                            type="button"
                            class="onboarding__icon-button"
                            (click)="dismiss()"
                            [attr.aria-label]="'onboarding.dismiss' | translate"
                            [title]="'onboarding.dismiss' | translate">
                            <i-feather name="x" class="onboarding__icon"></i-feather>
                        </button>
                    </div>
                </header>

                <div
                    class="onboarding__bar"
                    role="progressbar"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    [attr.aria-valuenow]="progress">
                    <div class="onboarding__bar-fill" [style.width.%]="progress"></div>
                </div>

                <ol class="onboarding__steps">
                    @for (step of steps; track step.key) {
                        <li>
                            <a class="onboarding__step" [class.done]="isDone(step)" [routerLink]="step.route">
                                <span class="onboarding__check" aria-hidden="true">
                                    @if (isDone(step)) {
                                        <i-feather name="check"></i-feather>
                                    }
                                </span>
                                <span class="onboarding__step-text">
                                    <span class="onboarding__step-title">{{ step.label + '.title' | translate }}</span>
                                    <span class="onboarding__step-hint">{{ step.label + '.hint' | translate }}</span>
                                </span>
                                <span class="visually-hidden">
                                    {{ (isDone(step) ? 'onboarding.done' : 'onboarding.open') | translate }}
                                </span>
                            </a>
                        </li>
                    }
                </ol>

                @if (isComplete) {
                    <div class="onboarding__complete">
                        <p>{{ 'onboarding.complete' | translate }}</p>
                        <button type="button" class="onboarding__finish" (click)="dismiss()">
                            {{ 'onboarding.finish' | translate }}
                        </button>
                    </div>
                }
            </div>
        }
    </aside>
}
